<section id="filterTag">
  <div class="q-filter-badge-wrapper" #BadgeWrapper>
    <ng-container *ngFor="let filter of ListFilterWithoutHiddenBadge | slice:0:BadgeSliceEnd">
      <div class="q-filter-badge">
        <div class="q-filter-badge-value"><strong>{{filter.Text}}:</strong>{{filter.Value}}</div>
        <button class="q-filter-badge-button" (click)="RazFilter(filter)"><i class="fas fa-times"></i></button>
      </div>
    </ng-container>

    <div *ngIf="BadgeExpendNumber>0 || BadgeExpended" class="q-filter-badge-more" (click)="BadgeExpend()" #BadgeExpendBtn>
      <div class="q-filter-badge-value"><strong *ngIf="!BadgeExpended">+{{BadgeExpendNumber}}</strong><strong *ngIf="BadgeExpended">Afficher moins</strong></div>
    </div>
    
    <div *ngIf="ListFilterWithoutHiddenBadge.length > 1" (click)="RazFilter(null)" class="q-filter-badge-clearall" #ClearAllBtn>
      <strong><i class="fas fa-times"></i></strong>Tout effacer
    </div>
  </div>
</section>
